import {
  JobsResponse,
  JobsResponseItem
} from '@/types/service-response'
import store from '@/store'
import { QcqCommonGridItem, UiLanguageItem, UiLanguageList } from '@/types'

export interface JobsItem {
  id: number
  code: string
  description: string
}

export class Jobs {
  private constructor (
    readonly dataMap: Map<string, JobsItem>
  ) {}

  get commonGridData (): QcqCommonGridItem {
    const selectedUiLanguage: UiLanguageItem | undefined = store.state.selectedUiLanguage
    const value = this.dataMap.get(selectedUiLanguage!.code)
    const newItem: QcqCommonGridItem = {
      id: value!.id,
      code: value!.code,
      description: value!.description
    }
    return newItem! // TODO CAN BE UNDEFINED
  }

  static createListFromResponse (responseData: JobsResponse): Array<Jobs> {
    const levelOfEducationList: Array<Jobs> = []
    let result: Map<number, Array<JobsResponseItem>> = new Map()
    const languageList: UiLanguageList = store.state.uiLanguageList

    responseData.forEach((responseItem: JobsResponseItem) => {
      if (!result.has(responseItem.BerufeID)) {
        result.set(responseItem.BerufeID, [responseItem])
      } else {
        result.get(responseItem.BerufeID)!.push(responseItem)
      }
    })

    result.forEach((responseItemArray: Array<JobsResponseItem>) => {
      let dataMap: Map<string, JobsItem> = new Map()
      responseItemArray.forEach((responseItem: JobsResponseItem) => {
        const languageItem = languageList.find((languageItem: UiLanguageItem) => languageItem.syzId === responseItem.SpracheID)
        if (languageItem) {
          let row: JobsItem = {
            id: responseItem.BerufeID,
            code: responseItem.BerufeCode,
            description: responseItem.BildungsgradeBezeichnung
          }
          dataMap.set(languageItem.code, row)
        }
      })
      levelOfEducationList.push(new Jobs(dataMap))
    })
    return levelOfEducationList
  }
}